namespace GeniuzPOS.AdvPromo {
    export enum amtqtyPmType {
        amtqtyFg0 = 0,
        amtqtyFg1 = 1
    }
    Serenity.Decorators.registerEnumType(amtqtyPmType, 'GeniuzPOS.AdvPromo.amtqtyPmType');
}
